import { __rest } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * @module
 *
 * This file is slimmed down copy of the MenuButton implementation in nova-commons.
 * The important difference is that this menu button has some bold text (the value after the field text).
 * If that was supported in nova-commons, then this wouldn't be needed.
 */
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { ButtonVariant } from '@sas/nova-commons/components/Button';
/* eslint-disable no-restricted-imports */
import { BaseButton } from '@sas/nova-commons/components/Button/__internal__/BaseButton';
import { BaseMenuButton, getMenuButtonTokens, } from '@sas/nova-commons/components/MenuButton/__internal__';
/* eslint-enable no-restricted-imports */
import { renderInlineCssVars, useDesignTokens } from '@sas/nova-commons/theme';
import { Icon } from '@sas/nova-commons/components/Icon';
import { ArrowSmallDownBtn } from '@sas/react-svg';
import { InfoBarState } from '../../store/infoBar/InfoBarState';
import { createUseHtmlId } from '@sas/nova-commons/hooks/useHtmlId';
import { selectInfoBarState, selectStyleState } from '../../store/selectors';
import { filterUndefined } from '../utils/style';
import cx from 'classnames';
import cn from './InfoBar.css.json';
import './InfoBar.css';
const useLabelId = createUseHtmlId('InfoBarMenuButtonLabel');
const InfoBarMenuButtonBase = (props) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    const dt = useDesignTokens();
    const labelId = useLabelId();
    if (props.state === undefined) {
        return null;
    }
    else if (props.state.sections === undefined) {
        return (_jsxs("div", Object.assign({ className: cn.readOnlyContainer, style: renderInlineCssVars({
                fg: (_c = (_b = (_a = props.style) === null || _a === void 0 ? void 0 : _a.normal) === null || _b === void 0 ? void 0 : _b.fg) !== null && _c !== void 0 ? _c : dt.reportTokens.text.basic.fg,
                'font-size': (_f = (_e = (_d = props.style) === null || _d === void 0 ? void 0 : _d.font) === null || _e === void 0 ? void 0 : _e.fontSize) !== null && _f !== void 0 ? _f : dt.reportTokens.font.size.m,
                'font-family': (_j = (_h = (_g = props.style) === null || _g === void 0 ? void 0 : _g.font) === null || _h === void 0 ? void 0 : _h.fontFamily) !== null && _j !== void 0 ? _j : dt.reportTokens.font.family,
            }, 'info') }, { children: [!!props.state.field && (_jsx("span", Object.assign({ className: cx(cn.menuButtonLabel, props.state.italicizeField && cn.italic) }, { children: props.state.field }))), !!props.state.value && (_jsx("span", Object.assign({ className: cn.menuButtonValue, title: (_k = props.state) === null || _k === void 0 ? void 0 : _k.tooltip }, { children: props.state.value })))] })));
    }
    else {
        return (_jsx(BaseMenuButton, { sections: props.state.sections, onItemSelected: (location) => {
                if (props.state) {
                    const notify = props.actions.notifyMenuButtonSelection;
                    notify(props.id, {
                        menuButtonIndex: props.index,
                        location,
                        menu: props.state,
                    });
                }
            }, text: props.state.value, renderButton: (_a) => {
                var _b, _c, _d, _e, _f;
                var { setButtonRef, menuIsOpen, text } = _a, buttonProps = __rest(_a, ["setButtonRef", "menuIsOpen", "text"]);
                return (_jsxs(BaseButton, Object.assign({}, buttonProps, { tokens: () => getMenuButtonTokens(!!menuIsOpen, buttonProps.variant, text, dt), theme: () => {
                        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
                        return filterUndefined({
                            '--button-fg': (_b = (_a = props.style) === null || _a === void 0 ? void 0 : _a.normal) === null || _b === void 0 ? void 0 : _b.fg,
                            '--button-hover-fg': (_d = (_c = props.style) === null || _c === void 0 ? void 0 : _c.normal) === null || _d === void 0 ? void 0 : _d.fg,
                            '--button-active-fg': (_f = (_e = props.style) === null || _e === void 0 ? void 0 : _e.normal) === null || _f === void 0 ? void 0 : _f.fg,
                            '--button-font-size': (_h = (_g = props.style) === null || _g === void 0 ? void 0 : _g.font) === null || _h === void 0 ? void 0 : _h.fontSize,
                            '--button-fontFamily': (_k = (_j = props.style) === null || _j === void 0 ? void 0 : _j.font) === null || _k === void 0 ? void 0 : _k.fontFamily,
                        });
                    }, style: { fontFamily: (_c = (_b = props.style) === null || _b === void 0 ? void 0 : _b.font) === null || _c === void 0 ? void 0 : _c.fontFamily }, className: cx(cn.menuButton, buttonProps.className), ref: setButtonRef, variant: ButtonVariant.Light, "aria-haspopup": true, ariaLabelledBy: labelId }, { children: [_jsx("span", Object.assign({ id: labelId, className: cx(cn.menuButtonLabel, ((_d = props.state) === null || _d === void 0 ? void 0 : _d.italicizeField) && cn.italic) }, { children: (_e = props.state) === null || _e === void 0 ? void 0 : _e.field })), _jsx("span", Object.assign({ className: cn.menuButtonValue, title: (_f = props.state) === null || _f === void 0 ? void 0 : _f.tooltip }, { children: text })), _jsx(Icon, { theme: () => ({ '--icon-default-override-fg': 'currentcolor' }), className: cn.menuButtonArrow, icon: ArrowSmallDownBtn, tooltip: "", ariaHidden: true })] })));
            } }));
    }
};
export const InfoBarMenuButton = connect((state, props) => {
    var _a;
    const menuButtonData = (_a = selectInfoBarState(state, props.id).menuButtons) === null || _a === void 0 ? void 0 : _a[props.index];
    return { state: menuButtonData, style: selectStyleState(state, props.id) };
}, (dispatch) => ({
    actions: bindActionCreators(InfoBarState.actions, dispatch),
}))(InfoBarMenuButtonBase);
